/**
 * Portfolio 默认定位逻辑 Hook
 * Invest Portfolio 仅 EXTERNAL；不再依赖 userFolders。
 */

import { useMemo } from "react";
import { PortfolioType } from "@/src/components/Portfolio/types";

export interface UsePortfolioDefaultLocationReturn {
  /** 默认的 Portfolio 类型 */
  defaultType: PortfolioType;
  /** 是否正在初始化 */
  isInitializing: boolean;
  /** 是否有收藏资产（Watchlist） */
  hasWatchlistAssets: boolean;
  /** 是否有外部导入账号 */
  hasExternalAccounts: boolean;
}

export const usePortfolioDefaultLocation =
  (): UsePortfolioDefaultLocationReturn => {
    return useMemo(
      () => ({
        defaultType: PortfolioType.EXTERNAL,
        isInitializing: false,
        hasWatchlistAssets: false,
        hasExternalAccounts: true,
      }),
      [],
    );
  };
